import React, { useEffect } from "react";
import ddbg from "../../assets/images/bg/ddbg.svg";
import noisebg from "../../assets/images/bg/noise.png";

const NoiseBackground = () => {
    return (
        <>
            <div
                className="z-0 fixed top-0 left-0 w-full h-full pointer-events-none"
                style={{
                    backgroundImage: `url(${noisebg})`,
                    backgroundRepeat: 'repeat',
                    opacity: 0.25,
                    mixBlendMode: 'soft-light',
                    zIndex: 0,
                }}
            ></div>

            <img src={ddbg} alt="DODEAL" className="fixed top-0 left-0 right-0 bottom-0 w-full h-full object-cover"
                style={{
                    zIndex: -3
                }} />
        </>
    )
}

export default NoiseBackground;